<template>
  

<div  class="card  shadow border border-white bg-white h-100 pb-3 overflow-auto">


        <div class="row pb-1 border-bottom border-info m-3">


                <h4 class="font-weight-lighter text-info"> <span class="fa fa-file-alt"></span> Bon De  {{ itemFormBon.is_recep ? 'Réception' : 'Sorties'}} </h4> 
            
        </div>
        
          <div class="row m-4">

        <div class="col-md-8 ml-auto mr-auto">

           <form @submit.prevent="handleSubmitBonCMD()">

            <div class="row ">
            <div class="form-group col">
                <label for="qte">Bon :</label>
                <input :disabled="nom_dis" type="text" v-model="itemFormBon.nom" id="qte" name="qte" class="form-control"
                 :class="{ 'is-invalid': isSubmitted && $v.itemFormBon.nom.$error }"/>
                 
                <div v-if="isSubmitted && !$v.itemFormBon.nom.required" class="invalid-feedback">Ce champ est obligatoire !!</div>


            </div>


            <div class="form-group col">
                <label for="date_exp" class="mr-sm-2">Date :</label>
                    <b-form-datepicker
                    class="mr-sm-2"
                    id="datepicker-date_exp"
                    placeholder="date"
                    v-model="itemFormBon.date"
                    :date-format-options="{day: 'numeric' , month: 'numeric',year: 'numeric' }"
                    locale="fr" />
            </div>


            </div>




            <div class="form-group mt-2">
            <label for="adresse">Note</label>
            <textarea name="adresse" id="adresse"  rows="2" class="form-control" v-model="itemFormBon.description"></textarea>
            </div>


            <div class="form-group">
                <button type="submit" class="btn  btn-primary btn-block">Valider</button>
            </div>

        </form>

        </div>   

</div> 

    
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>

 </div>






  
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {required} from "vuelidate/lib/validators";

export default {
 props: ['ResivedId','recp'],
 
computed: {
    user_name() {

      if(this.$store.getters.get_user)
      {
            return this.$store.getters.get_user.name;
      }
      else
      {
            return '';
      }
    },


  },
mounted(){

            //indentifier le type:
            if(typeof this.recp !== 'undefined')
            {
            this.itemFormBon.is_recep=this.recp
            }




            if(this.ResivedId)
            {
            this.process_modification(this.ResivedId)
            }
            else
            {
            this.process_Ajouter()
            }

    },
data () {
		return {

            itemFormBon: {
                    id:"",
                    nom:'___',
                    date:new Date().toJSON().slice(0,10).replace(/-/g,'-'),
                    valider:false,
                    is_recep:true,
                    description:'',
                    user:'user'},

            isSubmitted: false,
            isLoading: false,
            isModification:false,


            //boninfos Champs disibl:
            nom_dis:true,
        


		}
    },
    validations: {
            itemFormBon: {
                nom: {
                    required
                },
                date: {
                    required
                },
                valider: {
                    required
                },
                is_recep: {
                    required
                },
                
                user: {
                    required
                }
            }

    },
methods:{

        process_modification(id_resived)
        {
                    this.isLoading=true;
                    this.$http.get('/prodReceptions/'+id_resived)
                    .then((result) => {
                    
                    //affectation des information
                    this.itemFormBon.id=result.data.data.id,
                    this.itemFormBon.nom=result.data.data.nom,
                    this.itemFormBon.date=result.data.data.date,
                    this.itemFormBon.valider=result.data.data.valider,
                    this.itemFormBon.is_recep=result.data.data.is_recep,
                    this.itemFormBon.description=result.data.data.description,
                    this.itemFormBon.user=result.data.data.user




                    //boninfos Champs disibl:
                        this.nom_dis=false,
                     


                     //Activer la modification
                     this.isModification=true,


                     //desible load
                     this.isLoading=false;
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

        },
        process_Ajouter()
        {

            this.itemFormBon.total_ttc=0

                    //boninfos Champs disibl:
                        this.nom_dis=true,
              

                     //Activer la modification
                     this.isModification=false

        },

        handleSubmitBonCMD(){
                //USER HANDLE
                this.itemFormBon.user= this.user_name



                this.isSubmitted = true;

                this.$v.$touch();
                if (this.$v.$invalid) {
                this.flashMessage.show({
                status: 'info',
                title: 'Vérifiez les données et Reésayez !!',
                })
                }
                else 
                {


                    if(this.isModification)
                    {
                
                    this.edit_bon()
                    }
                    else
                    {
                    
                    this.add_bon()
                    }
   

                }


        },
        add_bon()
        {

            this.isLoading=true;

            this.$http.post('/prodReceptions',{

                    nom:this.itemFormBon.nom,
                    date:this.itemFormBon.date,
                    valider:this.itemFormBon.valider,
                    is_recep:this.itemFormBon.is_recep,
                    description:this.itemFormBon.description,
                    user:this.itemFormBon.user
                })
                .then(response => {
                    //metre a jour id
                    this.itemFormBon.id=response.data.data.id,
                    this.itemFormBon.nom=response.data.data.nom,

                    //boninfos Champs disibl:
                    this.nom_dis=false,
          
                    //Activer la modification
                    this.isModification=true,

                    this.isLoading=false;
                    //afficher message
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données sauvegardées',
                    message: 'Les données sont sauvegardées correctement '


                })
                    //afficher les details:


                    this.preparerDetail(
                    response.data.data.id,
                    response.data.data.nom
                    )

                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


               this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Sauvegarde',
                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                })
                });


        },
        edit_bon()
        {

            this.isLoading=true;

            this.$http.patch('/prodReceptions/'+this.itemFormBon.id,{

                    nom:this.itemFormBon.nom,
                    date:this.itemFormBon.date,
                    valider:this.itemFormBon.valider,
                    is_recep:this.itemFormBon.is_recep,
                    description:this.itemFormBon.description,
                    depot_id:this.itemFormBon.depot_id,
                    user:this.itemFormBon.user
                })
                .then(response => {

                    this.isLoading=false;
                    console.log(response.data.data);


                    //afficher message
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données sauvegardées',
                    message: 'Les données sont sauvegardées correctement '
                })

                //afficahge detail

                    this.preparerDetail(
                    response.data.data.id,
                    response.data.data.nom
                    )

                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


               this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Sauvegarde',
                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                })
                });


        },
        preparerDetail(id_bon,nom)
        {

                        this.$router.push({ 
                        name: 'prodReceptionDetails', 
                        params: { 
                        idBon: id_bon,
                        nomBon: nom,
                        is_recep:this.itemFormBon.is_recep
                        } 
                            });
        }

        



},
components: {
              Loading      
}


}
</script>

<style>

</style>